export function getAddressComponent(response, type) {
    if (response.status === "OK") {
        let addr = response.results[0].address_components;

        for (let i = 0; i < addr.length; i++) {
            let obj = addr[i];
            for (let key in obj) {
                let attrName = key;
                let attrValue = obj[key];
                if (obj.types[0] === type && attrName === "short_name") {
                    return attrValue;
                }
            }
        }
        return "";
    }
}

export function getAddressComponentWithSublocations(response, type) {
    if (response.status === "OK") {
        let addr = response.results[0].address_components;

        for (let i = 0; i < addr.length; i++) {
            let obj = addr[i];
            for (let key in obj) {
                let attrName = key;
                let attrValue = obj[key];
                for (let j = 0; j < obj.types.length; j++) {
                    if (obj.types[j] === type && attrName === "short_name") {
                        return attrValue;
                    }
                }
            }
        }
        return "";
    }
}

export function getFormattedAddress(response) {
    if (response.status === "OK") {
        let addr = response.results[0].formatted_address;
        if (addr) {
            return addr
        }
    }

}

// google geocode service Url
// https://maps.googleapis.com/maps/api/geocode/json?address=47541+USA&key=XXXXXXXXXXX Example Get Request to verify Zip Code 
// https://maps.googleapis.com/maps/api/geocode/json?address=431+18th+Street+Parkway,+Washington,+20006+US&key=XXXX Example Get Request to verify Address 
// https://6uoxfphxv8.execute-api.us-east-1.amazonaws.com/le/homefirecampaign?pilot=<addcode>
export async function callVerification(hfcUrl, type, value) {
    if (type && value) {
        const response = await fetch(
            hfcUrl + "?"+type+"=" + value
        );
        if (response.ok) {
            return response.json();
        } else {
            throw new Error(response);
        }
    }
}